import type { ReactNode } from 'react';

export type TtqWorkbenchFocusEmphasis = 'left' | 'right';

type TtqWorkbenchFocusLayoutProps = {
  /** 是否启用左右分栏（宽屏双栏 / 窄屏堆叠） */
  split?: boolean;
  source: ReactNode;
  derived?: ReactNode;
  emphasis?: TtqWorkbenchFocusEmphasis;
};

/** 品题工作台内容分栏：窄屏或单栏模式全宽；宽屏双栏时可切换侧重 */
export function TtqWorkbenchFocusLayout({
  split = false,
  source,
  derived,
  emphasis = 'left',
}: TtqWorkbenchFocusLayoutProps) {
  const showDerived = Boolean(split && derived);
  const gridClass = showDerived
    ? (emphasis === 'left'
      ? 'lg:grid-cols-[minmax(0,1.38fr)_minmax(240px,0.62fr)]'
      : 'lg:grid-cols-[minmax(240px,0.62fr)_minmax(0,1.38fr)]')
    : '';

  return (
    <div className={`grid w-full grid-cols-1 gap-4 lg:items-start ${gridClass}`}>
      <div className="min-w-0 space-y-4">
        {source}
      </div>
      {showDerived ? (
        <aside className="min-w-0">
          {derived}
        </aside>
      ) : null}
    </div>
  );
}
